import { EntityTypes, SalesTypes } from 'context/entityContext';

/**
 * getInitialSalesType returns the correct sales type to request from any /browse/{entityType} endpoint, depending on the current context.
 */
export default function getInitialSalesType(
  doNotUseAlbumEquivalents: boolean,
  currentEntityType?: EntityTypes
): SalesTypes | undefined {
  // Labels do not have sales types.
  if (currentEntityType === 'label') return undefined;

  // External users shouldn't see equivalents but streaming data
  if (doNotUseAlbumEquivalents) return 'streaming';

  // Internal users should see streaming
  return 'streaming';
}
